const pessoaMutation = {
    ADD_PESSOA_PARTICIPANTE: (state, payload) => {
        state.participante = payload;
    },
    ADD_TOKEN_SESSAO_PARTICIPANTE:(state, payload) => {
        state.tokenSessao = payload;
    }
}

export default pessoaMutation;


// WEBPACK FOOTER //
// ./src/store/mutations/pessoa.mutation.js